"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludeSwaggerTelemetryProcessor = void 0;
const excludeSwaggerTelemetryProcessor = ({
  data
}) => {
  if (data.baseType === 'RequestData' && data.baseData?.name?.startsWith('GET /swagger')) {
    return false;
  }
  if (data.baseType === 'RemoteDependencyData' && data.baseData?.properties?.url?.startsWith('/swagger')) {
    return false;
  }
  return true;
};
exports.excludeSwaggerTelemetryProcessor = excludeSwaggerTelemetryProcessor;
